import { configureStore } from '@reduxjs/toolkit';
import formReducer from './formSlice';
import authReducer from './authSlice';
import courseReducer from "./courseSlice";
import topicReducer from "./topicSlice";
import organisationalReducer from "./organisationalSlice";
import seminarsSlice from "./seminarsSlice";

const store = configureStore({
    reducer: {
        form: formReducer,
        auth: authReducer,
        courses: courseReducer,
        topics: topicReducer,
        seminar: seminarsSlice,
        organisationalStructure: organisationalReducer,
    },
});

export default store;
